import { Component, Input } from "@angular/core";
import { IPackageHistory } from "src/app/models/history.model";

@Component({
    selector: "app-package-detail-history-tab",
    templateUrl: "./package-detail-history-tab.component.html",
    styleUrls: ["./package-detail-history-tab.component.scss"],
})
export class PackageDetailHistoryTabComponent {
    signature: string;

    @Input()
    history: IPackageHistory[];

    constructor() {}
}
